const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	analytics_summary : null,
	analytics_details : [],
	analytics_questions_date : [],
	analytics_questions_category : []
}

const getters = {
	fetchAnalyticsSummary : (state) => state.analytics_summary,
	fetchAnalyticsDetails : (state) => state.analytics_details,
	fetchAnalyticsQuestionsPracticedByDate : (state) => state.analytics_questions_date,
	fetchAnalyticsQuestionsPracticedByCategory : (state) => state.analytics_questions_category
}

const actions = {
	loadAnalyticsSummary({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`analytics/summary?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_ANALYTICS_SUMMARY', response.data)
		})
	},

	loadAnalyticsDetails({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`analytics/details?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_ANALYTICS_DETAILS', response.data)
		})
	},

	loadAnalyticsQuestionsPracticedByDate({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`analytics/numquestionsdate?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_ANALYTICS_QUESTIONS_PRACTICED_BY_DATE', response.data)
		})
	},

	loadAnalyticsQuestionsPracticedByCategory({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`analytics/numquestionscategory?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_ANALYTICS_QUESTIONS_PRACTICED_BY_CATEGORY', response.data)
		})
	}
}

const mutations = {
	SET_ANALYTICS_SUMMARY : (state, summary) => {
		state.analytics_summary = summary
	},
	SET_ANALYTICS_DETAILS : (state, details) => {
		state.analytics_details = details
	},
	SET_ANALYTICS_QUESTIONS_PRACTICED_BY_DATE : (state, details) => {
		state.analytics_questions_date = details
	},
	SET_ANALYTICS_QUESTIONS_PRACTICED_BY_CATEGORY : (state, details) => {
		state.analytics_questions_category = details
	}
}

export default {
	state, getters, actions, mutations
}